import { render, staticRenderFns } from "./clover.vue?vue&type=template&id=060f5fc6"
import script from "./clover.vue?vue&type=script&lang=js"
export * from "./clover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports